import {
  styled,
  Theme,
  WithTheme,
  Tooltip as BaseTooltip,
} from '@material-ui/core'
import { ReactComponent as BaseWhiteLogo } from 'shared/images/CashCollectorLogoWhite.svg'
import { ReactComponent as BaseGradientLogo } from 'shared/images/CashCollectorLogoWithTextGradient.svg'
import { ReactComponent as ChevronRight } from 'shared/icons/chevron_right.svg'

const SIDE_NAV_DYNAMIC_WIDTH = (isExpanded: boolean) => (isExpanded ? 260 : 80)
const EXPAND_ICON_POSITION = { top: 430, right: -22 }
const EXPAND_ICON_SIZE = 40
const WHITE_LOGO_WIDTH = 52 * 1.1
const WHITE_LOGO_HEIGHT = 49 * 1.1

const GRADIENT_LOGO_WIDTH = 220
const GRADIENT_LOGO_HEIGHT = WHITE_LOGO_HEIGHT

interface ArrowProps extends WithTheme {
  direction?: 'left' | 'right'
}

export const WhiteLogo = styled(BaseWhiteLogo)({
  width: WHITE_LOGO_WIDTH,
  height: WHITE_LOGO_HEIGHT,
})

export const GradientLogo = styled(BaseGradientLogo)({
  width: GRADIENT_LOGO_WIDTH,
  height: GRADIENT_LOGO_HEIGHT,
})

export const Container = styled('div')({
  display: 'flex',
  position: 'fixed',
  zIndex: 900,
  height: '100%',
})

export const SideNavigation = styled('div')(
  ({ theme, isExpanded }: { theme: Theme; isExpanded: boolean }) => ({
    background: isExpanded
      ? theme.palette.common.white
      : `linear-gradient(0deg, #71F48A 0%, ${theme.palette.primary.main} 65.96%)`,
    width: SIDE_NAV_DYNAMIC_WIDTH(isExpanded),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: '0px 20px 0px 0px',
    padding: theme.spacing(4, 2, 2, 1),
    transitionDuration: '.3s',
    transitionProperty: 'width, background',
    overflow: 'hidden',
    boxShadow:
      '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
  })
)

export const LogoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(7),
}))

export const NavigationContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingRight: theme.spacing(0.2),
}))

export const UserActionsContainer = styled('div')(
  ({ theme, isExpanded }: { theme: Theme; isExpanded: boolean }) => ({
    display: 'flex',
    flexDirection: 'column',
    '& button': {
      ...(isExpanded
        ? {
            color: theme.palette.grey[100],
            '&:hover': {
              color: theme.palette.primary.main,
            },
          }
        : {
            color: theme.palette.common.white,
            '&:hover': {
              color: theme.palette.common.white,
            },
          }),
    },
  })
)

export const NavigationSectionsContainer = styled('div')({
  height: '90%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})

export const IconContainer = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  overflow: 'visible',
  '& svg': {
    fontSize: 30,
  },
}))

export const ExpandIconContainer = styled('div')(
  ({ theme }: { theme: Theme; isExpanded: boolean }) => ({
    position: 'absolute',
    cursor: 'pointer',
    right: EXPAND_ICON_POSITION.right,
    top: EXPAND_ICON_POSITION.top,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    backgroundColor: theme.palette.common.white,
    width: EXPAND_ICON_SIZE,
    height: EXPAND_ICON_SIZE,
    boxShadow: '0px 0px 10px 5px rgba(0,0,0,0.05)',
    transition: 'box-shadow 0.3s',
    '& > *': {
      color: theme.palette.primary.dark,
    },
    '&:hover': {
      boxShadow: '0px 0px 10px 5px rgba(0,0,0,0.20)',
    },
  })
)

export const Arrow = styled(ChevronRight)(
  ({ theme, direction = 'right' }: ArrowProps) => ({
    color: theme.palette.primary.dark,
    userSelect: 'none',
    transform: `rotateZ(${direction === 'left' ? 180 : 0}deg)`,
    transition: 'transform 0.3s',
  })
)

export const Tooltip = styled(BaseTooltip)(({ theme }) => ({
  '&:not(:last-child)': {
    marginBottom: theme.spacing(0.6),
  },
}))
